<template>
  <modal :show="show" @change="$emit('change',$event)" width="370">
    <template v-slot:header></template>
    <template v-slot:main>
      <div class="modal-info text-center mx-7">
        <div class="modal-info__message fs-18 pb-5"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'"
        >{{attentionText}}</div>
      </div>
      <div class="text-center pb-3">
        <v-btn
          outlined
          class="outlined-transparent-button mr-4"
          @click="closeDeleteDialog"
          :disabled="loading"
        >{{$t('buttons.cancel')}}</v-btn>

        <v-btn color="red" dark @click="deleteItem" :loading="loading">{{$t('buttons.delete')}}</v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters } from "vuex";

export default {
  name: "ModalDelete",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    attentionText: String,
    loading: Boolean
  },
  data: () => ({
    message: ""
  }),
  computed: {
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {
    closeDeleteDialog() {
      this.$emit("closeDeleteDialog");
    },
    deleteItem() {
      this.$emit("deleteItem");
    }
  },
  created() {},
  watch: {}
};
</script>

<style scoped lang="scss">
.modal-info {
  min-height: 100px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}
</style>
